import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { dayforceKeys } from './keys'
import { listDayforceBookings } from 'api/admin/dayforce/listDayforceBookings'

export const useDayforceBookingsQuery = (
  request: Parameters<typeof listDayforceBookings>[0]
) => {
  const { searchTerm } = request

  return useQuery({
    queryKey: dayforceKeys.bookingsList(request),
    queryFn: () => listDayforceBookings(request),
    placeholderData: keepPreviousData,
    enabled: !!searchTerm,
  })
}
